import * as Yup from 'yup';
import YupPassword from 'yup-password';
YupPassword(Yup);

const createCapitalEntryValidation = Yup.object().shape({
  type: Yup.string().required(),
  quantity: Yup.number().required()
});

export default createCapitalEntryValidation;
